/* istanbul ignore file */
import { Show } from 'framework/show';
import { useServiceService } from 'domain/shared/service';
import { useServiceId } from 'domain/organization/service/useServiceId';
import ViewProjectPageContent from 'domain/organization/service/Show/ViewServicePageContent';

const ViewService = () => {
  const id = useServiceId();
  const { getById } = useServiceService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ViewProjectPageContent />
    </Show>
  );
};

export default ViewService;
